import React, { useEffect, useRef } from "react";
import cardImg1 from "./images/cardMenuImg1.webp";
import cardImg2 from "./images/cardMenuImg2.webp";
import cardImg3 from "./images/cardMenuImg3.webp";
import cardImg4 from "./images/cardMenuImg4.webp";

const cards = [
  {
    img: cardImg1,
    span: 7,
    w: "86%",
    title: "AI-powered conversations",
    desc:
      "Deliver natural, human-like chats with AI that understands intent, resolves queries instantly and keeps conversations engaging 24×7.",
    // desc:
    // "Turn every WhatsApp interaction into a meaningful conversation — AI qualifies leads, recommends products, and boosts conversions effortlessly.",
    bg: "#FFEEE6",
    hM: "340px",
    hD: "400px",
    imgM: "190px",
    imgD: "250px",
  },
  {
    img: cardImg2,
    span: 5,
    w: "87%",
    title: "A Chatbot Builder for Non-techies",
    desc:
      "Build multiple WhatsApp Chatbots easily, thanks to a drag-and-drop interface that requires zero coding expertise.",
    bg: "#F3E6FF",
    hM: "300px",
    hD: "360px",
    imgM: "180px",
    imgD: "240px",
  },
  {
    img: cardImg3,
    span: 5,
    w: "87%",
    title: "Automated WhatsApp Support & Sales",
    desc:
      "Provide instant support and boost sales on WhatsApp with AI-powered automation that works round the clock.",
    // desc:
    //   "Streamline your support and sales with intelligent WhatsApp automation designed to engage customers 24×7.",
    bg: "#C8E4F5",
    hM: "300px",
    hD: "360px",
    imgM: "180px",
    imgD: "240px",
  },
  {
    img: cardImg4,
    span: 7,
    w: "86%",
    title: "Guide customers smarter with WhatsApp Flows",
    // desc:
    //   "Use interactive WhatsApp Flows to guide users through bookings, purchases, and support with ease and clarity..",
    desc:
      "Use interactive WhatsApp Flows to guide users through bookings, purchases, and support with ease and clarity..",

    bg: "#E6F4EA",
    hM: "320px",
    hD: "380px",
    imgM: "190px",
    imgD: "250px",
  },
];

const CardMenu_Section = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("reveal-up");
          io.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="cardmenu pre"
      style={{
        overflow: "hidden",
        marginTop: 80,
      }}
    >
      <div
        className="mx-auto position-relative"
        style={{
          maxWidth: "74%",
          zIndex: 1,
          padding: "0 16px",
        }}
      >
        {/* Heading */}
        <div style={{ marginTop: "40px", textAlign: "center" }}>
          <h2
            style={{
              fontSize: "44px",
              fontFamily: "Inter",
              fontWeight: 650,
              color: "#242121ff",
              lineHeight: 1,
            }}
          >
            Add-on Feature
          </h2>
          <p
            className="mt-2"
            style={{
              color: "#413e3e",
              fontSize: "1.1rem",
              lineHeight: 1.2,
              fontFamily: "Poppins",
            }}
          >
            Unlock our advanced drag-and-drop Flow Builder for just ₹1999/month and
            start automating support, lead qualification and product guidance instantly.
          </p>
        </div>
        {/* CTA under the cards */}
        <div className="cta-wrap">
          <a href="#pricing" className="btn-green glass-sweep" aria-label="Explore Plans & Pricing">
            <span>Explore Plans & Pricing</span>
            <span className="arrow">→</span>
          </a>
        </div>

        {/* Cards */}
        <div className="cards-grid">
          {cards.map((c, i) => (
            <article
              key={i}
              className={`card span-${c.span}`}
              style={{
                backgroundColor: c.bg,
                "--card-w": c.w || "100%",
                "--card-h-m": c.hM || "300px",
                "--card-h-d": c.hD || "360px",
                "--img-h-m": c.imgM || "180px",
                "--img-h-d": c.imgD || "240px",
              }}
            >
              <div className="card-inner">
                <figure className="card-media">
                  <img src={c.img} alt={c.title} loading="lazy" />
                </figure>
                <div className="card-body">
                  <h3 className="card-title">{c.title}</h3>
                  <p className="card-desc">{c.desc}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
      
      <style>{`
        /* ===== Section background (light blue + light green mix, white fade bottom) ===== */
        .cardmenu{
          background:
            linear-gradient(to bottom, rgba(255,255,255,0) 78%, rgba(255,255,255,1) 100%),
            radial-gradient(900px 600px at 0% 0%, rgba(191,228,255,.32) 0%, rgba(191,228,255,0) 60%),
            radial-gradient(900px 600px at 100% 0%, rgba(192,252,226,.24) 0%, rgba(192,252,226,0) 60%),
            linear-gradient(135deg, #E9F1FF 0%, #EFFFF7 100%);
        }

        /* ===== Reveal on view (bottom -> top) ===== */
        .pre { opacity: 0; transform: translateY(24px); }
        .reveal-up { animation: fadeUp .7s ease-out forwards; }
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ===== Grid ===== */
        .cards-grid{
          display: grid;
          grid-template-columns: repeat(12, 1fr);
          --card-gap: 12px;               /* one place to customize spacing */
          column-gap: var(--card-gap);
          row-gap: var(--card-gap);
          padding-top: 38px;    
          padding-bottom: 60px;
        }
        @media (max-width: 992px){
          .cards-grid{ grid-template-columns: 1fr; }
        }

        /* width spans (desktop) */
        .span-7{ grid-column: span 7; }
        .span-5{ grid-column: span 5; }
        @media (max-width: 992px){
          .span-7, .span-5{ grid-column: span 12; }
        }

        /* ===== Card ===== */
        .card{
          width: var(--card-w, 100%);
          justify-self: start;             /* edge hugging controlled per-row below */
          border-radius: 14px;
          padding: 0;                      
          min-height: var(--card-h-m, 300px);
          box-shadow: 0 6px 16px rgba(16,24,40,.06);
          overflow: hidden;               
          background-clip: padding-box;
        }
        @media (min-width: 768px){
          .card{ min-height: var(--card-h-d, 360px); }
        }

        /* Inner wrapper receives the hover transform (no layout shift/overflow) */
        .card-inner{
          height: 100%;
          display: grid;
          grid-template-rows: auto 1fr;
          padding: 22px;
          transition: transform .25s ease, box-shadow .25s ease;
        }
        .card:hover .card-inner{
          transform: translateY(-3px);
        }

        /* media area */
        .card-media{
          display:flex; 
          align-items:center; 
          justify-content:center;
          padding: 4px 8px 0;
        }
        .card-media img{
          width: 100%;
          max-height: var(--img-h-m, 180px);
          object-fit: contain;
          display:block;
          -webkit-mask-image: linear-gradient(black, transparent);
          mask-image: linear-gradient(to bottom, black 76%, rgba(0,0,0,.25) 92%, 
          transparent 100%);
        }
        @media (min-width: 768px){
          .card-media img{ max-height: var(--img-h-d, 240px); }
        }

        /* text */
        .card-body{ margin-top: 10px; }
        .card-title{
          margin: 6px 0 6px;
          font-size: 20px;
          font-family: Inter;
          font-weight: 600;
          color: #242121ff;
        }
        @media (min-width: 768px){
          .card-title{ 
              font-size: 1.35rem; 
          }
        }
        .card-desc{
          margin: 0;
          color: #525252;
          font-size: 15px;
          font-family: Poppins;
          font-weight: 300;
          line-height: 1.2
        }

        /* ===== Pair-wise alignment (desktop) ===== */
        @media (min-width: 993px){
          /* Row 1 (left big hugs right, right small hugs left) */
          .cards-grid > .card:nth-child(1){ justify-self: end; }
          .cards-grid > .card:nth-child(2){ justify-self: start; }

          /* Row 2 (same hugging pattern) */
          .cards-grid > .card:nth-child(3){ justify-self: end; }
          .cards-grid > .card:nth-child(4){ justify-self: start; }

          /* small, constant right shift for 3 & 4 (no overflow; hover keeps it) */
          .cards-grid > .card:nth-child(3),
          .cards-grid > .card:nth-child(4){
            --shift-x: 36px;                         /* tweak here if you want more/less */
            transform: translateX(var(--shift-x));
          }
          .cards-grid > .card:nth-child(3):hover .card-inner,
          .cards-grid > .card:nth-child(4):hover .card-inner{
            transform: translateY(-3px);             /* same hover depth, no extra X-move */
          }
        }

        /* ===== CTA ===== */
        .cta-wrap{
          margin-top: 28px;
          display: flex;
          justify-content: center;
        }
        .btn-green{
          --btn-radius: 10px;
          display: inline-grid;
          grid-auto-flow: column;
          align-items: center;
          gap: 10px;
          padding: 12px 20px;
          border-radius: var(--btn-radius);
          background: #10B264;                 /* bright green */
          color: #fff;
          text-decoration: none;
          font: 600 16px/1 Inter, system-ui, sans-serif;
          box-shadow: 0 6px 16px rgba(16,24,40,.08);
          position: relative;
          overflow: hidden;
          transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
        }
        .btn-green .arrow{ font-weight: 700; }
        .btn-green:hover{
          transform: translateY(-2px);
          box-shadow: 0 10px 22px rgba(16,24,40,.12);
          background: #0FA85F;
        }
        /* glass/mirror sweep */
        .glass-sweep::after{
          content: "";
          position: absolute;
          top: 0; bottom: 0;
          width: 45%;
          left: -60%;
          background: linear-gradient(
            105deg,
            rgba(255,255,255,0) 0%,
            rgba(255,255,255,0.45) 40%,
            rgba(255,255,255,0.15) 60%,
            rgba(255,255,255,0) 100%
          );
          transform: skewX(-18deg);
          transition: left .6s ease;
          pointer-events: none;
        }
        .glass-sweep:hover::after{
          left: 120%;
        }
        .btn-green:focus-visible{
          outline: 3px solid rgba(79,195,255,.55);
          outline-offset: 2px;
        }
      `}</style>
    </section>
  );
};

export default CardMenu_Section;
